import styles from "../../../../styles/animation.module.css";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export interface Option {
  color: string;
  amount: number;
  percentage: number;
  key: string;
}

export interface MobileStackedProgressBarProps {
  loading: boolean;
  gtgEnabled: boolean;
  selected: "MTD" | "YTD" | "WTD";
  title: string;
  options: Option[];
  className?: string;
  tooltip: (option: Option) => string;
}

export const MobileStackedProgressBar = ({
  loading,
  gtgEnabled,
  selected,
  title,
  options,
  tooltip,
}: MobileStackedProgressBarProps) => {
  return (
    <div className="flex flex-col gap-1">
      <span className="text-xs font-medium text-foreground">{title}</span>
      <div className="relative h-3 w-full rounded-full overflow-hidden bg-muted">
        {loading ? (
          <div
            key={selected + gtgEnabled + "loading"}
            className="absolute inset-0 animate-pulse bg-muted-foreground/20 rounded-full"
          />
        ) : (
          <div
            key={selected + gtgEnabled}
            className={`${styles.bar} flex h-full w-full`}
          >
            {options &&
              options.map((option) => (
                <div
                  key={option.key}
                  style={{
                    width: `${option.percentage}%`,
                    backgroundColor: option.color,
                  }}
                />
              ))}
          </div>
        )}
      </div>
      <div className="flex flex-wrap gap-x-3 gap-y-1">
        <TooltipProvider>
          {options &&
            options.map((option) => (
              <Tooltip key={option.key}>
                <TooltipTrigger asChild>
                  <div className="flex items-center gap-1 cursor-default">
                    <div
                      className="w-2 h-2 rounded-sm shrink-0"
                      style={{ backgroundColor: option.color }}
                    />
                    <span
                      className={
                        "text-xs text-muted-foreground " +
                        (option.key === "DLA" ? "uppercase" : "capitalize")
                      }
                    >
                      {option.key.toLowerCase().replace("_", " ")}
                    </span>
                  </div>
                </TooltipTrigger>
                <TooltipContent side="top" className="text-xs">
                  {tooltip(option)}
                </TooltipContent>
              </Tooltip>
            ))}
        </TooltipProvider>
      </div>
    </div>
  );
};

export default MobileStackedProgressBar;
